import { render, staticRenderFns } from "./LocalisationDestinations.vue?vue&type=template&id=c493f1de&"
import script from "./LocalisationDestinations.vue?vue&type=script&lang=ts&"
export * from "./LocalisationDestinations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports